import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SelfTruncatingPathModule } from '@portal-core/general/components/self-truncating-path/self-truncating-path.module';
import { ListItemActionsModule } from '@portal-core/ui/list/directives/list-item-actions/list-item-actions.module';
import { ListItemLineModule } from '@portal-core/ui/list/directives/list-item-line/list-item-line.module';
import { PathListItemComponent } from './path-list-item.component';

@NgModule({
  declarations: [
    PathListItemComponent
  ],
  imports: [
    CommonModule,
    ListItemActionsModule,
    ListItemLineModule,
    SelfTruncatingPathModule
  ],
  exports: [
    ListItemActionsModule,
    ListItemLineModule,
    PathListItemComponent
  ]
})
export class PathListItemModule { }
